import { useState } from "react";
import { CONTACT, WORDS } from "../constant/global";
import About from "../sections/About";
import Blog from "../sections/Blog";
import Contact from "../sections/Contact";
import Portfolio from "../sections/Portfolio";
import Resume from "../sections/Resume";
import "../style/css/globals.css";
import { HiChevronDown } from "react-icons/hi";
import Navbar from "../components/Navbars/Navbar";

function Home() {
  const [navAktiv, setNavAktiv] = useState(0);
  const [sidebar, setSidebar] = useState(false);

  let section;
  switch (navAktiv) {
    case 0:
      section = <About />;
      break;
    case 1:
      section = <Resume />;
      break;
    case 2:
      section = <Portfolio />;
      break;
    case 3:
      section = <Blog />;
      break;
    case 4:
      section = <Contact />;
      break;
    default:
      section = <About />;
  }

  return (
    <main>
      <aside className={`sidebar ${sidebar && "active"}`} data-sidebar>
        <div className="sidebar-info">
          <figure className="avatar-box">
            <img
              src={require("../assets/images/avatar/me.png")}
              alt={WORDS.nama}
              width={80}
            />
          </figure>
          <div className="info-content">
            <h1 class="name" title={WORDS.nama}>
              {WORDS.nama}
            </h1>
            <p className="title">{WORDS.job}</p>
          </div>
          <button
            className="info_more-btn"
            onClick={() => setSidebar(!sidebar)}
          >
            <span>Show Contacts</span>
            <HiChevronDown />
          </button>
        </div>
        <div className="sidebar-info_more">
          <div className="separator" />
          <ul className="contacts-list">
            {CONTACT?.map((x) => (
              <a href={x.href} key={x.title}>
                <li className="contact-item">
                  <div className="icon-box">{x.icon}</div>
                  <div className="contact-info">
                    <p className="contact-title">{x.title}</p>
                    <p className="contact-link">{x.label}</p>
                  </div>
                </li>
              </a>
            ))}
          </ul>
          <div className="separator" />
          {/* <ul className="social-list">
            <li className="social-item">
              <button href="#" className="social-link">
                <HiLocationMarker />
              </button>
            </li>
          </ul> */}
        </div>
      </aside>
      <div className="main-content">
        <Navbar navAktiv={navAktiv} setNavAktiv={setNavAktiv} />
        {section}
      </div>
    </main>
  );
}

export default Home;
